<template>
    <div>
        <!--THEME IMAGE : This image changes dynamically when a theme is chosen in a Details step.-->
        <!--The Details step must be the 1st step, and the Theme must be the 1st piece.-->
        <label class="control-label">{{ pieceName }}</label>
        <p class="piece-instructions" v-if="pieceOptions.instructions" v-html="pieceOptions.instructions"></p>

        <img v-if="imageLoaded" class="step-image" :src="escapeHtml(stripSlashes((pieceOptions && pieceOptions.template).replace('[THEME]', firstPieceContentFromFirstStep)))" />
        <input type="hidden" :name="'pieces[' + pieceIndex + '][content]'" :value="escapeHtml(stripSlashes(pieceOptions.template.replace('[THEME]', firstPieceContentFromFirstStep)))">
        <div class="step-spacer"></div>
    </div>
</template>

<script>

    import utils from "../../../../mixins/utils";
    import {getCampaignStepPieces} from '../../../../utility/api/campaign/getCampaignStepPieces';

    export default {
        name: 'theme-image-piece',
        mixins: [utils],
        data() {
            return {
                firstPieceContentFromFirstStep: '',
                imageLoaded: false
            };
        },
        methods: {
            loadPiecesFromFirstCampaignStep() {
                return getCampaignStepPieces(this.campaignId, this.firstStepId).then(responseData => responseData.data);
            }
        },
        props: {
            campaignId: {
                type: Number,
                required:true
            },
            pieceIndex: {
                type: Number,
                required:true
            },
            pieceName: {
                type: String,
                required:true
            },
            pieceContent: {
                type: String,
                required:true
            },
            pieceOptions: {
                type: Object,
                required:true
            },
            pieceData: {
              type: Object,
              required:true
            },
			firstStepId: {
				type: Number,
				required:true
			},
        },
        mounted() {
            this.loadPiecesFromFirstCampaignStep().then( (pieces) => {
                this.firstPieceContentFromFirstStep = pieces[0].content;
                this.imageLoaded = true;
            });

        }
    }
</script>

<style lang="scss">

</style>

